import React, { CSSProperties } from "react"
import { useRecoilValue } from "recoil"
import { Box, Flex, Image } from "@chakra-ui/react"
import { brandingSelector } from "../../../recoil/atoms/room"
import { productOverlaySelector } from "../../../recoil/atoms/product-overlay"
import { useWatchParty } from "../../../hooks/useWatchParty"
type PiPBgBoxProps = {
  styles?: CSSProperties
  text?: string
  coverImage?: string
  isMobile?: boolean
  toggleShowLeaveOverlay?: (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => void
  handleTouchStart?: (event: React.TouchEvent<HTMLElement>) => void
  toggleShowLeaveOverlayTouchEnd?: (
    event: React.TouchEvent<HTMLElement>
  ) => void
  isTouchDelay?: boolean
  isActiveScreen?: boolean
  isLandscape?: boolean
}

const PiPBgBox: React.FC<PiPBgBoxProps> = ({
  styles,
  text = "",
  coverImage,
  isMobile,
  toggleShowLeaveOverlay,
  isTouchDelay,
  handleTouchStart,
  toggleShowLeaveOverlayTouchEnd,
  isActiveScreen,
  isLandscape
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { isOpen } = useRecoilValue(productOverlaySelector)

  const { isWatchParty } = useWatchParty()
  return (
    <Flex
      w="100%"
      id="pip-box"
      h="100%"
      position="absolute"
      top="0"
      left="0"
      zIndex="13"
      fontSize="18px"
      borderRadius={!isMobile && !isWatchParty && "0.375rem"}
      bgColor={roomStyles?.alertBackgroundColor ?? "#FFFFFF"}
      textColor={roomStyles?.alertTextColor ?? "#000000"}
      fontFamily={roomStyles?.alertFontFamily ?? "inherit"}
      border={
        isActiveScreen &&
        `2px solid ${roomStyles.highlighterColor ?? "#000000"}`
      }
      style={{
        ...styles
      }}
      onClick={toggleShowLeaveOverlay}
      onTouchStart={!isTouchDelay ? handleTouchStart : null}
      onTouchEnd={!isTouchDelay ? toggleShowLeaveOverlayTouchEnd : null}
    >
      <Box
        overflow="hidden"
        borderRadius={!isMobile && "0.375rem"}
        width={"100%"}
        bg={
          roomStyles?.alertBackgroundColor !== ""
            ? roomStyles?.alertBackgroundColor
            : "black"
        }
      >
        <Image
          src={!isOpen && coverImage}
          maxW="100%"
          maxHeight="100%"
          height={"100%"}
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          margin="auto"
          borderRadius={"0.375rem"}
          objectFit={isMobile ? "cover" : "unset"}
        />
      </Box>
      {text}
    </Flex>
  )
}

export default PiPBgBox
